MachineryForm = App.loadClass "grower::viewmodels/machinery/Form"
ValidationEngine = App.loadClass "core::ValidationEngine"

class exports.DialogViewMachinery_Handler extends FullPageHandler

    constructor: () ->
        super()
        @wantEdit = false
        @wantAdd = false
        # This should be FALSE because we are manually refreshing
        @refreshNavHandler = false
        @machinery_id = null
        @machinery_type = null


    init: () ->
        @loadLayoutPostOptions =
            'id': @machinery_id
            'machinery_type_id': @machinery_type
        @layoutUrl  = 'backend/grower/machinery/load-layout-addedit'
        @createDialog()


    destroy: () ->
        ko.cleanNode @dialog[0]
        super()


    afterLoadLayout: (selector, response) ->
        if response.status?.type isnt 'success'
            @openDialog()
            return

        # Input Masking - for Fertilizer/Sprayer, Planter, and Tiller
        $.mask.definitions['m'] = '[.0-9]'
        @dialog.find('#swath_width').mask('?mmmmmm', { placeholder: "" })
        @dialog.find('#till_width').mask('?mmmmmm', { placeholder: "" })

        @dialog.find('#num_rows').mask('?99', { placeholder: "" })

        @successAction = () ->
            # App.current_page.refresh()
            @parent.refresh()

        ths = this
        # if not response.data
        #     console.log response
        @koData = new MachineryForm this, response.data?.type, response.data

        if @wantEdit or @wantAdd
            @koData.setEditing()


        ko.applyBindings @koData, @dialog[0]


        @validator = new ValidationEngine()

        @validator.makeFormValidator 'machinery', '.validationContainer', '#addedit_machinery_errors', (valid) =>
            if valid
                # Perform an action if the form successfully validated
                # @save('Creating User...')
                ths.save('Saving...')
            else
                # Perform an action if the form validation failed

        @validator.registerRule
            selector: '.validate-swath-till-width'
            text: '%s is too high or is an invalid decimal value'
            func: (elem) ->
                val = elem.val()
                return (not val or $(elem).val().match(/^\d{0,3}(\.\d{1})?$/))

        @validator.registerRule
            'selector': '.validate-maybe-required'
            'text': '%s is required'
            'func': (elem) ->
                if not ths.koData.layer.variable_rate()
                    return true
                else
                    if ths.koData.layer[$(elem).attr('name')]()?
                        return true
                return false

        @validator.registerRule
            'selector': '.validate-ko-required'
            'text': '%s is required'
            'func': (elem) ->
                if ths.koData.layer[$(elem).attr('name')]()?
                    return true
                return false

        @validator.registerRule
            'selector': '.validate-length'
            'text': '%s is too large'
            'func': (elem) ->
                return $(elem).val().length < 8

        @validator.registerRule
            'selector': '.validate-unique-nickname'
            'text': 'You have already used this nickname.  Please choose a unique nickname.'
            'ajax':
                'url': 'backend/grower/machinery/validate-unique-nickname'
                'data': (elem) ->
                    'nick': elem.val(),
                    'type': response.data?.type
                    'id': ths.koData.layer.id
            'func': (data) ->
                return data is 'good'

        # obj = {}
        # obj["##{@dialog.attr('id')}"] = () ->
        #     ths.save('Saving...')


        # setUpValidation obj

        # registerValidationRule 'validate-maybe-required','%s is required',(elem) ->
        #     if not ths.koData.layer.variable_rate()
        #         return true
        #     else
        #         if ths.koData.layer[$(elem).attr('name')]()?
        #             return true
        #     return false

        # registerValidationRule 'validate-ko-required','%s is required',(elem) ->
        #     if ths.koData.layer[$(elem).attr('name')]()?
        #         return true
        #     return false

        @openDialog()


    getPostData: () ->
        datac = $.extend(true, {}, @koData.layer)
        delete datac.machinery_subtypes
        delete datac.machinery_makes
        delete datac.machinery_models
        delete datac.controller_makes
        delete datac.controller_models
        delete datac.selected_subtype
        delete datac.selected_make
        if datac.selected_controller_make? and datac.selected_controller_make()?
            datac.selected_controller_make().models = null
            delete datac.selected_controller_make().models

        if datac.nickname()
            datac.nickname datac.nickname().replace('&', '', 'g')

        data = "json=" + ko.toJSON datac
        return data


    submitAction: () ->
        # mfValidate()
        @validator.validateAll()
